import Main from './main';
import Edit from './edit';
import New from './new';
import Single from './single';

const routes = [
  {
    path: '/*',
    Component: Main,
    props: {
      exact: true,
    },
  },
  {
    path: '/:id/edit',
    name: 'edit-invoice',
    Component: Edit,
    props: {
      exact: true,
    },
  },
  {
    path: '/:id',
    Component: Single,
    props: {
      exact: true,
    },
  },
  {
    path: '/new',
    name: 'new-invoice',
    Component: New,
    props: {
      isNew: true,
    },
  },
];

export default routes;
